import { render, staticRenderFns } from "./ShopMenuPublishersFilter.vue?vue&type=template&id=683070a7&scoped=true&"
import script from "./ShopMenuPublishersFilter.vue?vue&type=script&lang=js&"
export * from "./ShopMenuPublishersFilter.vue?vue&type=script&lang=js&"
import style0 from "./ShopMenuPublishersFilter.vue?vue&type=style&index=0&id=683070a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683070a7",
  null
  
)

export default component.exports